// ─── Protocole des canaux de prise en main (Telipso Assistance v2, §2) ───
// Trames binaires de l'agent : image (tuiles JPEG) et position du curseur.
// Tous les entiers sont big-endian (DataView par défaut).

export const BINAIRE = { IMAGE: 0x01, CURSEUR: 0x02 };

/** Codes de fermeture WebSocket propres à l'application. */
export const FERMETURE = {
  SESSION_TERMINEE: 4001,
  ACCES_REFUSE: 4003,
  INTROUVABLE: 4004,
  DELAI_DEPASSE: 4008,
  FIN_PAR_USAGER: 4010,
};

export function lireTrameImage(tampon) {
  const v = new DataView(tampon);
  if (v.getUint8(0) !== BINAIRE.IMAGE) throw new Error('Trame non IMAGE');
  const seq = v.getUint32(1);
  const largeur = v.getUint16(5);
  const hauteur = v.getUint16(7);
  const nb = v.getUint16(9);
  const tuiles = [];
  let p = 11;
  for (let i = 0; i < nb; i++) {
    const x = v.getUint16(p);
    const y = v.getUint16(p + 2);
    const l = v.getUint16(p + 4);
    const h = v.getUint16(p + 6);
    const taille = v.getUint32(p + 8);
    p += 12;
    tuiles.push({ x, y, largeur: l, hauteur: h, jpeg: new Uint8Array(tampon, p, taille) });
    p += taille;
  }
  return { seq, largeur, hauteur, tuiles };
}

/** (-1, -1) : pointeur hors de l'écran capturé. */
export function lireCurseur(tampon) {
  const v = new DataView(tampon);
  return { x: v.getInt16(1), y: v.getInt16(3) };
}

export function raisonFermeture(code, raison) {
  switch (code) {
    case FERMETURE.FIN_PAR_USAGER:
      return 'Session terminée par l’usager du poste.';
    case FERMETURE.SESSION_TERMINEE:
      return raison || 'La session est terminée.';
    case FERMETURE.ACCES_REFUSE:
      return 'Accès refusé.';
    case FERMETURE.INTROUVABLE:
      return 'Session terminée ou introuvable.';
    case FERMETURE.DELAI_DEPASSE:
      return 'Le poste n’a pas répondu.';
    default:
      return raison || 'Connexion fermée.';
  }
}

/** Fermetures qui signifient que la session entière est finie (pas seulement ce canal). */
export const estFinDeSession = (code) => code === FERMETURE.FIN_PAR_USAGER || code === FERMETURE.SESSION_TERMINEE;

export function urlWebSocket(path) {
  return (location.protocol === 'https:' ? 'wss://' : 'ws://') + location.host + path;
}
